import { Exercise } from "@tt-app/types";

export interface FlatExerciseListDetails {
  type: number;
  uuid: string;
}

export const flattenCourseExercises = (
  container: Exercise,
  result?: FlatExerciseListDetails[]
): FlatExerciseListDetails[] => {
  result = result || [];

  // container.contents for course details
  // container.exercises for assignment details
  const exerciseList = container?.contents || container?.exercises;

  if (!exerciseList && container?.exerciseType) {
    return [...result, { uuid: container.uuid, type: container.exerciseType }];
  }

  exerciseList?.forEach((subContainer: any) => {
    result = flattenCourseExercises(subContainer, result);
  });

  return result;
};
